import styled from 'styled-components';

import type { StatusBannerAutoHideProps } from '@xing-com/banner';
import { StatusBannerAutoHide } from '@xing-com/banner';

export const Feedback = styled(StatusBannerAutoHide)<StatusBannerAutoHideProps>`
  margin-bottom: 0;
`;
